<template>
  <div class="faq">
    <div class="headers">
       <div>
           <Input
             v-model="filterIds"
             placeholder="商品ID,逗号分隔"
             clearable
             style="min-width: 80px; width:150px; margin-left: 20px;"/>
           <Button @click="getRecords" style="margin-right: 10px;">搜索</Button>
           <Button @click="getRecords">刷新</Button>
       </div>
    </div>
    <Table :columns="columns" :data="data">
      <template slot-scope="{ row, index }" slot="id">
        <span>{{ row.id }}</span>
      </template>
		<template slot-scope="{ row, index }" slot="url">
		    <Poptip trigger="hover" :transfer="true" title="图片详情">
		        <div class="info-pop" slot="content">
		            <img :src="row.url">
		        </div>
		        <img :src="row.url" style="width: 50px;height: 50px;">
		    </Poptip>
		</template>
      <template slot-scope="{ row, index }" slot="priority">
        <span>{{ row.priority }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="category_id">
        <span>{{ row.category_id|getClassify }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="jewel_price">
        <span>{{ row.jewel_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="coin_price">
        <span>{{ row.coin_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="discount">
        <span>{{ row.discount|getDiscount }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="status">
        <span>{{ row.status|getStatus }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
          <div>
              <Button @click="handleToTop(row, index)">置顶</Button>
          </div>
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../../http/api";
import OSS from 'ali-oss';

export default {
  name: "faq",
  data() {
    return {
      filterIds: "",
      data: [],
      columns: [
		  {
		    title: '商品ID',
		    slot: 'id',
		    width: 0
		  },
		  {
		    title: '缩略图',
		    slot: 'url',
		    width: 0
		  },
        {
          title: '优先级',
          slot: 'priority',
          width: 80
        },
        {
          title: '类型',
          slot: 'category_id',
          // width: 120
        },
        {
          title: '用钻价格',
          slot: 'jewel_price',
          // width: 170
        },
        {
          title: '用币价格',
          slot: 'coin_price',
          // width: 170
        },
        {
          title: '折扣',
          slot: 'discount',
          // width: 170
        },
        {
          title: '状态',
          slot: 'status',
          // width: 170
        },
        {
          title: '操作',
          slot: 'action',
          // width: 270
        }
      ]
    }
  },
  async created() {
    await this.getRecords()
  },
  watch: {

  },
  methods: {
    async getRecords() {
      if(this.filterIds == undefined){
          this.filterIds = ""
      }
      let params = {
        'furniture_ids': this.filterIds
      }
      apis.furniture_personal_image_shop_all_records(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.data = data.records
        }
      }).catch(err => {

      })
    },
	figureImageSortToTop(index) {
	 
	  let post_data = {
	    furniture_id: this.data[index].id,
	  }
	  apis.furniture_personal_image_shop_sort_top(post_data).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode !== 0){
	      this.$Message.error(msg);
	    }
	    this.getRecords()
	  })
	},
	handleToTop(row, index) {
	  this.figureImageSortToTop(index);
	}
  },
  computed: {

  },
  filters:{
    getClassify(val){
      let categoryClassifyMap = {1: '墙漆', 2: '墙纸', 3: '地板', 4: '左侧柜子', 5: '徽章架', 6: '软装', 7: '挂饰', 8: '左右墙'}
      return categoryClassifyMap[val]
    },
    getDiscount(val){
      if (val > 0){
        return '可打折'
      }else {
        return '不可打折'
      }
    },
    getStatus(val) {
      if(val === 0){
        return '正常'
      }else if(val === -1){
        return '下架'
      } else if(val === -2){
        return '赠品'
      } else {
        return '异常'
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.headers {
  text-align: right;
  margin-bottom: 10px;
}

.headers button {
  margin-left: 10px;
}

.images-text {
  white-space: pre-wrap;
}

</style>